// Refreshes server-rendered Trustpilot numbers ([data-trustpilot-score] / [data-trustpilot-count])
// from the public TrustBox JSON (CORS open, cached 30 min). Runs once per page when idle;
// the server-rendered values stay if the request fails.
const URL =
  'https://widget.trustpilot.com/trustbox-data/5419b6a8b0d04a076446a9ad?businessUnitId=5ef78cd9e00d9200015055ae&locale=de-DE';

function update() {
  if (!document.querySelector('[data-trustpilot-score], [data-trustpilot-count]')) return;

  fetch(URL)
    .then((response) => (response.ok ? response.json() : null))
    .then((data) => {
      const unit = data?.businessUnit;
      if (!unit) return;

      const score = Number(unit.trustScore);
      const total = Number(unit.numberOfReviews?.total);

      if (score > 0) {
        const text = score.toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        for (const el of document.querySelectorAll('[data-trustpilot-score]')) el.textContent = text;
      }
      if (total > 0) {
        const text = total.toLocaleString('de-DE');
        for (const el of document.querySelectorAll('[data-trustpilot-count]')) el.textContent = text;
      }
    })
    .catch(() => {});
}

if ('requestIdleCallback' in window) requestIdleCallback(update, { timeout: 5000 });
else setTimeout(update, 2000);
